import axios from 'axios'
import { host } from '../../configuraciones'
import { createAsyncThunk, createSlice } from '@reduxjs/toolkit'

//constantes
const dataInicial = {
    data: {
        data: []
    },
    dataDescuento: {
        data: []
    }
}


//types
const OBTENER_DATOS_PREDIO_EXITO = 'OBTENER_DATOS_PREDIO_EXITO'
const OBTENER_DATOS_PREDIO_BY_ID_CLIENTE_EXITO = 'OBTENER_DATOS_PREDIO_BY_ID_CLIENTE_EXITO'
const OBTENER_DATOS_PREDIO_BY_NO_SOCIO_EXITO = 'OBTENER_DATOS_PREDIO_BY_NO_SOCIO_EXITO'
const AGREGAR_DATOS_PREDIO_EXITO = 'AGREGAR_DATOS_PREDIO_EXITO'
const ACTUALIZAR_DATOS_PREDIO_EXITO = 'ACTUALIZAR_DATOS_PREDIO_EXITO'
const GENERAR_CONSTANCIA_EXITO = 'GENERAR_CONSTANCIA_EXITO'
const OBTENER_DOMICILIO_CLIENTE_EXITO = 'OBTENER_DOMICILIO_CLIENTE_EXITO'
const OBTENER_DATOS_PREDIO_HISTORIAL_EXITO = 'OBTENER_DATOS_PREDIO_HISTORIAL_EXITO'
const OBTENER_DATOS_PREDIO_HISTORIAL_CLIENTE_EXITO = 'OBTENER_DATOS_PREDIO_HISTORIAL_CLIENTE_EXITO'
const OBTENER_DATOS_PREDIO_DESCUENTO_EXITO = 'OBTENER_DATOS_PREDIO_DESCUENTO_EXITO'
const OBTENER_DATOS_PREDIO_INFORMACION_CLIENTE_EXITO = 'OBTENER_DATOS_PREDIO_INFORMACION_CLIENTE_EXITO'
let idPredio = (number, len) => "0".repeat(len - number.toString().length) + number.toString();
const OBTENER_DATOS_PREDIO_PREDIO_EXITO = 'OBTENER_DATOS_PREDIO_PREDIO_EXITO'
const OBTENER_DATOS_PREDIO_REPORTE_EXITO = 'OBTENER_DATOS_PREDIO_REPORTE_EXITO'

export const obtenerTodosDatosPredio = createAsyncThunk(
    OBTENER_DATOS_PREDIO_EXITO,
    async () => {
        try {
            const fullUrl = host + `DatosPredio/obtenerTodosDatosPredio`
            const res = await axios.get(fullUrl)
            let data = []
            for (const i in res.data.data) {
                const { ...datosPredio } = res.data.data[i]
                let datosmaguey = []

                datosPredio.iddatospredio = idPredio(datosPredio.iddatospredio, 5)

                for (const i in datosPredio.datosmaguey) {
                    //if (datosPredio.datosmaguey?.[i]?.edad >= 5) {
                    datosmaguey.push(datosPredio.datosmaguey?.[i])
                    //}
                }
                datosPredio.datosmaguey = datosmaguey
                //if (datosPredio?.datosmaguey?.[datosPredio?.datosmaguey?.length-1]?.edad >= 5) {
                data.push(datosPredio)
                //}
            }
            return { data: { data } }
            //return data
        } catch (error) {
            console.log(error);
        }
    }
)
export const obtenerTodosDatosPredioByNoPredio = createAsyncThunk(
    OBTENER_DATOS_PREDIO_PREDIO_EXITO,
    async (numPredio) => {
        try {
            const fullUrl = host + `DatosPredio/obtenerTodosDatosPredioByNoPredio/${numPredio}`
            const res = await axios.get(fullUrl)
            let data = []
            for (const i in res.data.data) {
                const { ...datosPredio } = res.data.data[i]
                let datosmaguey = []

                datosPredio.iddatospredio = idPredio(datosPredio.iddatospredio, 5)

                for (const i in datosPredio.datosmaguey) {
                    //if (datosPredio.datosmaguey?.[i]?.edad >= 5) {
                    datosmaguey.push(datosPredio.datosmaguey?.[i])
                    //}
                }
                datosPredio.datosmaguey = datosmaguey
                //if (datosPredio?.datosmaguey?.[datosPredio?.datosmaguey?.length-1]?.edad >= 5) {
                data.push(datosPredio)
                //}
            }
            return { data: { data } }
            //return data
        } catch (error) {
            console.log(error);
        }
    }
)
export const obtenerDatosPredioByNoSocio = createAsyncThunk(
    OBTENER_DATOS_PREDIO_BY_NO_SOCIO_EXITO,
    async (numeroSocio) => {
        try {
            const fullUrl = host + `DatosPredio/obtenerDatosPredioByNoSocio/${numeroSocio}`
            const res = await axios.get(fullUrl)
            return res
        } catch (error) {
            console.log(error);
        }
    }
)

export const obtenerDatosPredioByIdCliente = createAsyncThunk(
    OBTENER_DATOS_PREDIO_BY_ID_CLIENTE_EXITO,
    async (idCliente) => {
        try {
            const fullUrl = host + `DatosPredio/obtenerDatosPredioByIdCliente/${idCliente}`
            const res = await axios.get(fullUrl)
            return res
        } catch (error) {
            console.log(error);
        }
    }
)

export const agregarDatosPredio = createAsyncThunk(
    AGREGAR_DATOS_PREDIO_EXITO,
    async (data) => {
        try {
            const fullUrl = host + `DatosPredio/agregarDatosPredio`
            const result = await axios.post(fullUrl, data)
            return result
        } catch (error) {
            console.log(error);
        }
    }
)
export const generarConstancia = createAsyncThunk(
    GENERAR_CONSTANCIA_EXITO,
    async (data) => {
        try {
            const fullUrl = host + `RegistroPredio/generarConstancia`
            const result = await axios.post(fullUrl, data)
            return result
        } catch (error) {
            console.log(error);
        }
    }
)

export const actualizarDatosPredio = createAsyncThunk(
    ACTUALIZAR_DATOS_PREDIO_EXITO,
    async (data) => {
        try {

            let kmlFile = data.data.kmlFile;
            delete data.data.kmlFile
            const fullUrl = host + `DatosPredio/actualizarDatosPredio`
            const result = await axios.put(fullUrl, data)

            if (kmlFile !== null && kmlFile !== undefined) {
                const iddatospredio = data.data.iddatospredio
                console.log(iddatospredio);
                const kmlUrl = host + `PoligonoKml/agregarPoligonoKml`
                let formData = new FormData()
                formData.append('archivo', kmlFile)
                formData.append('iddatospredio', iddatospredio)
                const resultado = await axios.post(kmlUrl, formData, {
                    headers: {
                        'Content-Type': 'multipart/form-data'
                    }
                })
                return resultado
            }
            return result
        } catch (error) {
            console.log(error);
        }
    }
)
export const obtenerDomicilioFiscal = createAsyncThunk(
    OBTENER_DOMICILIO_CLIENTE_EXITO,
    async (idCliente) => {
        try {
            const fullUrl = host + `InformacionValida/obtenerDomicilioFiscalByCliente/${idCliente}`
            const res = await axios.get(fullUrl)
            return res.data.data
        } catch (error) {
            console.log(error);
        }
    }
)
export const obtenerDatosPredioHistorial = createAsyncThunk(
    OBTENER_DATOS_PREDIO_HISTORIAL_EXITO,
    async (numPredioA) => {
        try {
            let numeroPredio = Number(numPredioA)
            const fullUrl = host + `DatosPredio/obtenerTodosDatosPredioHitorial/${numeroPredio}`
            const res = await axios.get(fullUrl)
            return res.data.data
        } catch (error) {
            console.log(error);
        }
    }
)
export const obtenerDatosCliente = createAsyncThunk(
    OBTENER_DATOS_PREDIO_HISTORIAL_CLIENTE_EXITO,
    async () => {
        try {
            const fullUrl = host + `DatosPredio/obtenerTodosDatosCliente`
            const res = await axios.get(fullUrl)
            return res.data.data
        } catch (error) {
            console.log(error);
        }
    }
)
export const obtenerTodosDatosPredioGenerarGuias = createAsyncThunk(
    OBTENER_DATOS_PREDIO_EXITO,
    async (numeroPredio) => {
        try {
            const fullUrl = host + `DatosPredio/obtenerTodosDatosPredioGenerarGuias/${numeroPredio}` 
            const res = await axios.get(fullUrl)
            let data = []
            for (const i in res.data.data) {
                const { ...datosPredio } = res.data.data[i]
                let datosmaguey = []

                datosPredio.iddatospredio = idPredio(datosPredio.iddatospredio, 5)

                for (const i in datosPredio.datosmaguey) {
                    //if (datosPredio.datosmaguey?.[i]?.edad >= 5) {
                    datosmaguey.push(datosPredio.datosmaguey?.[i])
                    //}
                }
                datosPredio.datosmaguey = datosmaguey
                //if (datosPredio?.datosmaguey?.[datosPredio?.datosmaguey?.length-1]?.edad >= 5) {
                data.push(datosPredio)
                //}
            }
            return { data: { data } }
            //return data
        } catch (error) {
            console.log(error);
        }
    }
)
export const obtenerTodosDatosPredioDescuento = createAsyncThunk(
    OBTENER_DATOS_PREDIO_DESCUENTO_EXITO,
    async () => {
        try {
            const fullUrl = host + `DatosPredio/obtenerTodosDatosPredio`
            const res = await axios.get(fullUrl)
            let data = []
            for (const i in res.data.data) {
                const { ...datosPredio } = res.data.data[i]
                let datosmaguey = []
                datosPredio.iddatospredio = idPredio(datosPredio.iddatospredio, 5)
                for (const i in datosPredio.datosmaguey) {
                    datosmaguey.push(datosPredio.datosmaguey?.[i])
                }
                datosPredio.datosmaguey = datosmaguey
                data.push(datosPredio)
            }
            return { data: { data } }
            //return data
        } catch (error) {
            console.log(error);
        }
    }
)
export const obtenerTodosDatosClienteInformacionPrediosBySocio = createAsyncThunk(
    OBTENER_DATOS_PREDIO_INFORMACION_CLIENTE_EXITO,
    async (numSocio) => {
        try {
            const fullUrl = host + `DatosPredio/obtenerTodosDatosClienteInformacionPrediosBySocio/${numSocio}`
            const res = await axios.get(fullUrl)
            return res.data.data
        } catch (error) {
            console.log(error);
        }
    }
)
export const obtenerTodosDatosClienteInformacionPrediosByRazon = createAsyncThunk(
    OBTENER_DATOS_PREDIO_INFORMACION_CLIENTE_EXITO,
    async (razonSocial) => {
        try {
            const fullUrl = host + `DatosPredio/obtenerTodosDatosClienteInformacionPrediosByRazon/${razonSocial}`
            const res = await axios.get(fullUrl)
            return res.data.data
        } catch (error) {
            console.log(error);
        }
    }
)
export const obtenerDatosPredioReporte = createAsyncThunk(
    OBTENER_DATOS_PREDIO_REPORTE_EXITO,
    async () => {
        try {
            const fullUrl = host + `DatosPredio/obtenerTodasDatosPredioReporte`;
            const res = await axios.get(fullUrl);
            return res.data.data
        } catch (error) {
            console.log(error);
        }
    }
);
export const datosPredioSlice = createSlice({
    name: 'datosPredioSlice',
    initialState: dataInicial,
    reducers: {
        setInitialData(state, { payload }) {
            return dataInicial
        }
    },
    extraReducers: {

        [obtenerTodosDatosPredio.fulfilled]: (state, { payload }) => {
            state.data = payload.data
        },
        [obtenerTodosDatosPredioByNoPredio.fulfilled]: (state, { payload }) => {
            state.data = payload.data
        },
        [obtenerTodosDatosPredioDescuento.fulfilled]: (state, { payload }) => {
            state.dataDescuento = payload.data
        },

        [agregarDatosPredio.fulfilled]: (state, { payload }) => {

        },

        [actualizarDatosPredio.fulfilled]: (state, { payload }) => {

        },

        [obtenerDatosPredioByNoSocio.fulfilled]: (state, { payload }) => {
            state.data = payload.data
        },

        [obtenerDatosPredioByIdCliente.fulfilled]: (state, { payload }) => {
            state.data = payload.data
        },

        [obtenerTodosDatosPredioGenerarGuias.fulfilled]: (state, { payload }) => {
            state.data = payload.data
        },
    },
})

export const {
    setInitialData
} = datosPredioSlice.actions
export const DatosPredioReducerUsuarioAgricola = datosPredioSlice.reducer
